import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import SectionTitleSpecial from '../../components/SectionTitle/SectionTitleSpecial';
import SingleCourse from '../../components/Course';
import RightArrow from '../../components/SVG';
import DataState from '../../components/DataState';
import { programPath } from '../../data';
import { useCollections } from '../../lib/api/collections';
import { programImages, sanasaAvatar40 as sanasaAvatar } from '../../data/images';

import courseBG from '../../assets/img/course/ed-bg-1.jpg';

const PAGE = 6;

// ?type=degree | diploma | short filters the list; no type shows everything.
const filters = {
  degree: { groups: ['Degree'], title: 'Degrees' },
  diploma: { groups: ['Diploma', 'Higher Diploma'], title: 'Diplomas' },
  short: { groups: ['Certificate', 'Short Program', 'Entrepreneur Program'], title: 'Short Courses' },
};

const CourseOneMain = () => {
  const content = useCollections('programs');
  const programs = content.programs || [];
  const [params] = useSearchParams();
  const type = params.get('type');
  const filter = filters[type];
  const list = filter ? programs.filter((p) => filter.groups.includes(p.group)) : programs;
  const [count, setCount] = useState(PAGE);

  useEffect(() => {
    setCount(PAGE);
  }, [type]);

  if (content.loading || content.error) return <DataState state={content} />;

  const shown = list.slice(0, count);
  const pageTitle = filter ? filter.title : 'Programs';

  return (
    <main>
      <Breadcrumb title={pageTitle} subTitle={pageTitle} />

      <div
        id="it-course"
        className="it-course-area ed-course-bg ed-course-style-3 p-relative pt-120 pb-90"
        style={{ backgroundImage: `url(${courseBG})` }}
      >
        <div className="container">
          <div className="ed-course-title-wrap mb-65">
            <div className="row align-items-center">
              <div className="col-xl-8 col-lg-8 col-md-7">
                <SectionTitleSpecial
                  itemClass="it-course-title-boxmb-70 section-title-fixed-width"
                  subTitle="Our Programs"
                  preTitle="Find The Right"
                  highlightText="Program"
                  postTitle={`For You.`}
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-5">
                {count < list.length && (
                  <div className="ed-course-button text-md-end">
                    <Link
                      className="ed-btn-theme"
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setCount(count + PAGE);
                      }}
                    >
                      Show More Programs
                      <i>
                        <RightArrow />
                      </i>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            {shown.map((p) => (
              <div key={p.id} className="col-xl-4 col-lg-6 col-md-6 mb-30">
                <SingleCourse
                  to={programPath(p)}
                  courseImage={programImages(p).card}
                  thumbText={p.tag}
                  price={p.price}
                  title={p.cardTitle}
                  lessonCount={p.schedule}
                  duration={p.duration}
                  studentCount={p.language}
                  authorAvatar={sanasaAvatar}
                  authorName={p.unit}
                  btnText="Enroll"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};
export default CourseOneMain;
